import {
  getToken,
  setToken,
  removeToken,
  getStoredUser,
  setStoredUser,
  removeStoredUser
} from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getStoredUser()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token || ''
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  CLEAR_AUTH(state) {
    state.token = ''
    state.userInfo = null
  }
}

const actions = {
  init({ commit }) {
    const token = getToken()
    const userInfo = getStoredUser()
    if (token) {
      commit('SET_TOKEN', token)
    }
    if (userInfo) {
      commit('SET_USER_INFO', userInfo)
    }
  },
  login({ commit }, payload) {
    const { token, id, userName, userAccount, userEmail, role } = payload
    const userInfo = { id, userName, userAccount, userEmail, role }
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    setToken(token)
    setStoredUser(userInfo)
  },
  logout({ commit }) {
    commit('CLEAR_AUTH')
    removeToken()
    removeStoredUser()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
